

<template>
  <div id="videoDetails">
    <div class="details-top">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        v-if="videoShow"
      ></video-player>
    </div>
    <div class="introduction">
      <div class="introduction-title">
        <b>{{ oneVideo.videoName }}</b>
        <span>{{ oneVideo.videoType }}</span>
      </div>
      <div class="briefIntroduction">
        {{ oneVideo.videoIntroduction }}
      </div>
      <div class="introduction-time">
        <div class="i-time">{{ oneVideo.createTime }}</div>
        <i class="el-icon-view"> {{ oneVideo.views }}</i>
      </div>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import { getAllVideoDetails, getAddress } from "@api/lishui";
import { Toast } from "vant";
export default {
  name: "videoDetails",
  props: {},
  components: {
    videoPlayer,
  },
  data() {
    return {
      videoShow: false,
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: "", // 路径
            type: "video/mp4", // 类型
          },
        ],
        poster: "你的封面地址", //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          // timeDivider: true,
          // durationDisplay: true,
          // remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      oneVideo: {},
    };
  },
  created() {
    this.getAddress();
  },
  mounted() {},
  watch: {},
  methods: {
    // 查看环境
    getAddress() {
      getAddress().then((res) => {
        if (res.data.code === "0000") {
          // if (res.data) {
          this.getAllVideo(res.data.data);
          // } else {
          //   this.getVideoDetail("https://lxqym-ent.yscredit.com");
          // }
        }
      });
    },
    getAllVideo(val) {
      getAllVideoDetails({ id: this.$route.query.id }).then((res) => {
        if (res.data.code === "0000") {
          this.videoShow = true;
          res.data.data.createTime = res.data.data.createTime.split(" ")[0];
          this.oneVideo = res.data.data || {};
          this.playerOptions.poster = this.oneVideo.imageUrl;
          this.playerOptions.sources[0].src =
            val +
            "/api/video/download?fileName=" +
            this.oneVideo.videoName +
            "&ossUrl=" +
            this.oneVideo.videoUrl;
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
            duration: 1000,
          });
        }
      });
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
#videoDetails {
  width: 100%;
  height: 100%;
  .introduction {
    padding: 12px;
    background-color: #ffffff;
    .introduction-title {
      b {
        font-size: 15px;
        letter-spacing: 1px;
      }
      span {
        display: inline-block;
        // width: 48px;
        padding: 2px 4px;
        height: 15px;
        line-height: 15px;
        font-size: 11px;
        background-color: #1677ff;
        color: #fff;
        margin-left: 10px;
        text-align: center;
      }
    }
    .briefIntroduction {
      height: 37px;
      font-size: 13px;
      color: #333333;
      margin-top: 4px;
      overflow: hidden;
      display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
      -webkit-line-clamp: 2; //规定行数
    }
    .introduction-time {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      color: #999999;
      margin-top: 11px;
    }
  }
}
</style>